// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeMenu_ThemeMenu__mghS\\+ {
  --highlight-color: \$globalHighlightColor;
  --inverted-highlight-color: \$globalHighlightColor;
  border-radius: 1rem;
  width: 5rem;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonDarkTheme__g0ZDZ {
  display: flex;
  cursor: pointer;
  width: 100%;
  background: none;
  font: inherit;
  color: inherit;
  justify-content: center;
  align-items: center;
  border: solid transparent;
  border-radius: 1rem;
  padding: 0.35vw !important;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonDarkTheme__g0ZDZ img {
  height: 1.5rem;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonDarkTheme__g0ZDZ:hover {
  border: solid var(--highlight-color);
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonDarkTheme__g0ZDZ {
  --highlight-color: #fafafa;
  --inverted-highlight-color: #454555;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonDarkTheme__g0ZDZ img {
  filter: invert(1);
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonLightTheme__LqgAg {
  display: flex;
  cursor: pointer;
  width: 100%;
  background: none;
  font: inherit;
  color: inherit;
  justify-content: center;
  align-items: center;
  border: solid transparent;
  border-radius: 1rem;
  padding: 0.35vw !important;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonLightTheme__LqgAg img {
  height: 1.5rem;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonLightTheme__LqgAg:hover {
  border: solid var(--highlight-color);
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonLightTheme__LqgAg {
  --highlight-color: #454555;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuButtonColorfulTheme__QDrmW {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  --highlight-color: #454555;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v {
  position: absolute;
  z-index: 1000;
  width: inherit;
  height: inherit;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v .ThemeMenu_elementDarkTheme__mhZ7U {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.8vh;
  cursor: pointer;
  font: inherit;
  padding: 0;
  width: inherit;
  height: inherit;
  border: solid transparent;
  border-radius: 1rem;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v .ThemeMenu_elementDarkTheme__mhZ7U:hover {
  border: solid var(--inverted-highlight-color);
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v .ThemeMenu_elementDarkTheme__mhZ7U {
  background: #fafafa;
  color: #212121;
  --inverted-highlight-color: #f6a3a0;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v .ThemeMenu_elementLightTheme__DFyeg {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.8vh;
  cursor: pointer;
  font: inherit;
  padding: 0;
  width: inherit;
  height: inherit;
  border: solid transparent;
  border-radius: 1rem;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v .ThemeMenu_elementLightTheme__DFyeg:hover {
  border: solid var(--inverted-highlight-color);
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v .ThemeMenu_elementLightTheme__DFyeg {
  background: #212121;
  color: #fafafa;
  --inverted-highlight-color: #f6a3a0;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v .ThemeMenu_elementColorfulTheme__MRCya {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.8vh;
  cursor: pointer;
  font: inherit;
  padding: 0;
  width: inherit;
  height: inherit;
  border: solid transparent;
  border-radius: 1rem;
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v .ThemeMenu_elementColorfulTheme__MRCya:hover {
  border: solid var(--inverted-highlight-color);
}
.ThemeMenu_ThemeMenu__mghS\\+ .ThemeMenu_themeMenuElements__RMm7v .ThemeMenu_elementColorfulTheme__MRCya {
  background: #212121;
  color: #fafafa;
}`, "",{"version":3,"sources":["webpack://./src/components/ThemeMenu/ThemeMenu.module.scss","webpack://./src/assets/_globalStyleElements.module.scss"],"names":[],"mappings":"AAEA;EACE,wCAAA;EACA,iDAAA;EAGA,mBCJmB;EDKnB,WAAA;AAHF;AAwBE;EAnBE,aAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBChBiB;EDiBjB,0BAAA;AAFJ;AAGI;EACE,cAAA;AADN;AAGI;EACE,oCAAA;AADN;AAKE;EAEE,0BAAA;EACA,mCAAA;AAJJ;AAKI;EACE,iBAAA;AAHN;AAOE;EA5BE,aAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBChBiB;EDiBjB,0BAAA;AAwBJ;AAvBI;EACE,cAAA;AAyBN;AAvBI;EACE,oCAAA;AAyBN;AAZE;EAGE,0BAAA;AAYJ;AATE;ECyBA,gBAAA;EACA,sBAAA;EACA,0CA9D6B;EDqC3B,0BAAA;AAaJ;AAVE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AAYJ;AAOI;EAhBE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,mBC/De;AD2ErB;AAXM;EACE,6CAAA;AAaR;AATI;EAEE,mBCnEa;EDoEb,cCrEY;EDsEZ,mCAAA;AAUN;AAPI;EAvBE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,mBC/De;ADgGrB;AAhCM;EACE,6CAAA;AAkCR;AAvBI;EAEE,mBC3EY;ED4EZ,cC3Ea;ED4Eb,mCAAA;AAwBN;AArBI;EA9BE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,mBC/De;ADqHrB;AArDM;EACE,6CAAA;AAuDR;AArCI;EAEE,mBClFY;EDmFZ,cClFa;ADwHnB","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.ThemeMenu {\n  --highlight-color : $globalHighlightColor;\n  --inverted-highlight-color : $globalHighlightColor;\n\n\n  border-radius: $globalBorderRadius;\n  width: 5rem;\n  @mixin themeMenuButtonStyling {\n    display: flex;\n    cursor: pointer;\n    width: 100%;\n    background: none;\n    font: inherit;\n    color: inherit;\n    justify-content: center;\n    align-items: center;\n    border: solid transparent;\n    border-radius: $globalBorderRadius;\n    padding: 0.35vw !important;\n    img {\n      height: 1.5rem;\n    }\n    &:hover {\n      border: solid var(--highlight-color);\n    }\n  }\n\n  .themeMenuButtonDarkTheme {\n    @include themeMenuButtonStyling;\n    --highlight-color: #{$globalHighlightColorDark};\n    --inverted-highlight-color: #{$globalHighlightColorLight};\n    img {\n      filter: invert(1);\n    }\n  }\n\n  .themeMenuButtonLightTheme {\n    @include themeMenuButtonStyling;\n\n    --highlight-color: #{$globalHighlightColorLight};\n  }\n\n  .themeMenuButtonColorfulTheme {\n    @include colorfulThemeContent;\n    --highlight-color: #{$globalHighlightColorLight};\n  }\n\n  .themeMenuElements {\n    position: absolute;\n    z-index: 1000;\n    width: inherit;\n    height: inherit;\n\n    @mixin themeMenuElementStyling {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-top: 0.8vh;\n      cursor: pointer;\n      font: inherit;\n      padding: 0;\n      width: inherit;\n      height: inherit;\n      border: solid transparent;\n      border-radius: $globalBorderRadius;\n      &:hover {\n        border: solid var(--inverted-highlight-color);\n      }\n    }\n\n    .elementDarkTheme {\n      @include themeMenuElementStyling;\n      background: $globalLightColor;\n      color: $globalDarkColor;\n      --inverted-highlight-color:  #{$globalHighlightColor};\n    }\n\n    .elementLightTheme {\n      @include themeMenuElementStyling;\n      background: $globalDarkColor;\n      color: $globalLightColor;\n      --inverted-highlight-color: #{$globalHighlightColor};\n    }\n\n    .elementColorfulTheme {\n      @include themeMenuElementStyling;\n      background: $globalDarkColor;\n      color: $globalLightColor;\n    }\n  }\n}\n","$globalFontFamily: 'Courier New', monospace;\n$globalFontSize: 1.2rem;\n\n$globalBorderRadius: 1rem;\n$globalHomeContentContainerPadding: 2.5rem;\n\n$globalDarkColor: #212121;\n$globalLightColor: #fafafa;\n$globalUnderlayRGBAColorDark: rgba(255, 255, 255, 0.05);\n$globalUnderlayRGBAColorLight: rgba(208, 209, 255, 0.5);\n\n$globalHighlightColor: #f6a3a0;\n$globalHighlightColorDark: #fafafa;\n$globalHighlightColorLight: #454555;\n\n\n$colorsReact: #61dafb;\n$colorsKotlin: #7f52ff;\n$colorsReactRgba: rgba(97, 218, 251, 0.2);\n\n$gradientColor1: #845ec2;\n$gradientColor1: #d65db1;\n$gradientColor1: #ff9671;\n$gradientColor1: #ffc75f;\n$gradientColor1: #f9f871;\n\n@mixin darkTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalDarkColor;\n  color: $globalLightColor;\n  a {\n    color: white;\n  }\n}\n\n@mixin lightTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalLightColor;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin colorfulTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: #91f88b;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin darkThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorDark;\n}\n\n@mixin lightThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n\n@mixin colorfulThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ThemeMenu": `ThemeMenu_ThemeMenu__mghS+`,
	"themeMenuButtonDarkTheme": `ThemeMenu_themeMenuButtonDarkTheme__g0ZDZ`,
	"themeMenuButtonLightTheme": `ThemeMenu_themeMenuButtonLightTheme__LqgAg`,
	"themeMenuButtonColorfulTheme": `ThemeMenu_themeMenuButtonColorfulTheme__QDrmW`,
	"themeMenuElements": `ThemeMenu_themeMenuElements__RMm7v`,
	"elementDarkTheme": `ThemeMenu_elementDarkTheme__mhZ7U`,
	"elementLightTheme": `ThemeMenu_elementLightTheme__DFyeg`,
	"elementColorfulTheme": `ThemeMenu_elementColorfulTheme__MRCya`
};
export default ___CSS_LOADER_EXPORT___;
